"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TELEMETRY_PATHS = exports.listUsersQuerySchema = exports.pingSchema = exports.authOptionsSchema = exports.AUTH_OPTIONS_PATH = exports.healthSchema = exports.errorSchema = exports.idParamSchema = exports.userPublicSchema = void 0;
// @vbltc/schema — the T11 source of truth. Server routes and web forms import from here.
// Database tables live under "@vbltc/schema/db" (server only); permissions under "@vbltc/schema/permissions".
const zod_1 = require("zod");
__exportStar(require("./permissions.js"), exports);
__exportStar(require("./aco/format.js"), exports);
__exportStar(require("./aco/performance-rows.js"), exports);
__exportStar(require("./aco/scoring.js"), exports);
__exportStar(require("./aco/npi.js"), exports);
__exportStar(require("./aco/clinician.js"), exports);
__exportStar(require("./aco/access.js"), exports);
__exportStar(require("./aco/access-scope.js"), exports);
__exportStar(require("./aco/api/groups.js"), exports);
__exportStar(require("./aco/api/performance-workbook.js"), exports);
__exportStar(require("./aco/api/measures.js"), exports);
__exportStar(require("./aco/api/patients.js"), exports);
__exportStar(require("./aco/api/data-quality.js"), exports);
__exportStar(require("./aco/api/summary.js"), exports);
__exportStar(require("./aco/api/loads.js"), exports);
__exportStar(require("./aco/api/bundles.js"), exports);
__exportStar(require("./aco/api/bundle-differences.js"), exports);
__exportStar(require("./aco/api/patient-logic.js"), exports);
__exportStar(require("./aco/api/calculations.js"), exports);
__exportStar(require("./aco/api/demo-resets.js"), exports);
__exportStar(require("./aco/api/config-documents.js"), exports);
__exportStar(require("./aco/api/organization-mismatches.js"), exports);
__exportStar(require("./aco/api/admin.js"), exports);
__exportStar(require("./aco/api/gap-workbook-uploads.js"), exports);
__exportStar(require("./aco/api/account-email.js"), exports);
__exportStar(require("./aco/api/user-uploads.js"), exports);
__exportStar(require("./aco/config/config-issue.js"), exports);
__exportStar(require("./aco/config/organization.js"), exports);
__exportStar(require("./aco/config/measures.js"), exports);
__exportStar(require("./aco/config/benchmarks.js"), exports);
__exportStar(require("./aco/config/cross-check.js"), exports);
__exportStar(require("./aco/config/synthetic.js"), exports);
__exportStar(require("./aco/config/synthetic-cross-check.js"), exports);
__exportStar(require("./aco/config/ui.js"), exports);
__exportStar(require("./aco/config/mapping.js"), exports);
__exportStar(require("./aco/config/report-rules.js"), exports);
__exportStar(require("./aco/bundle.js"), exports);
__exportStar(require("./academy.js"), exports);
var schema_js_1 = require("./db/schema.js");
Object.defineProperty(exports, "userPublicSchema", { enumerable: true, get: function () { return schema_js_1.userPublicSchema; } });
// ---------- shared API primitives (land in OpenAPI components via .meta({ id })) ----------
exports.idParamSchema = zod_1.z.object({ id: zod_1.z.uuid() });
exports.errorSchema = zod_1.z
    .object({
    error: zod_1.z.string(),
    message: zod_1.z.string(),
    requestId: zod_1.z.string(),
    reason: zod_1.z.string().optional(),
    issues: zod_1.z
        .array(zod_1.z.object({ path: zod_1.z.array(zod_1.z.union([zod_1.z.string(), zod_1.z.number()])), message: zod_1.z.string() }))
        .optional(),
})
    .meta({ id: "ApiError" });
exports.healthSchema = zod_1.z
    .object({
    status: zod_1.z.literal("ok"),
    db: zod_1.z.enum(["ok", "error"]),
    /** The image's short SHA (J-177); release-smoke.sh compares it with the released tag. */
    version: zod_1.z.string(),
    /** J-302: the release version, YYYY.M.N (the Nth merge to main that month), or `dev`. */
    release: zod_1.z.string(),
    /** J-302: the 40-character commit the image was built from, or `dev`. */
    sha: zod_1.z.string(),
    /** J-302: when the image was built (ISO 8601 UTC); null for a server not built by vbltc-ci. */
    builtAt: zod_1.z.string().nullable(),
    /** J-302: the server's APP_ENV: development, test, qa or prod. */
    environment: zod_1.z.enum(["development", "test", "qa", "prod"]),
    requestId: zod_1.z.string(),
})
    .meta({ id: "Health" });
/** J-257: the public read the sign-in page makes before anyone signs in. */
exports.AUTH_OPTIONS_PATH = "/api/auth-options";
/**
 * J-257: what the sign-in page may offer. `passwordResetByEmail` is true when the server has a mail
 * transport (`MAIL_TRANSPORT` is not `none`), so "Forgot password?" can send a link.
 */
exports.authOptionsSchema = zod_1.z
    .object({ passwordResetByEmail: zod_1.z.boolean() })
    .meta({ id: "AuthOptions" });
exports.pingSchema = zod_1.z
    .object({ pong: zod_1.z.literal(true), role: zod_1.z.string() })
    .meta({ id: "AdminPing" });
// No `.meta({ id })` on a querystring or params schema. An id makes the type provider emit a $ref to
// a component, and @fastify/swagger expands parameters INLINE, so it cannot resolve one.
exports.listUsersQuerySchema = zod_1.z.object({
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(20),
});
/** Public telemetry contract: browser OTLP/JSON posts to these same-origin paths (CR-13). */
exports.TELEMETRY_PATHS = {
    traces: "/api/telemetry/v1/traces",
    logs: "/api/telemetry/v1/logs",
};
__exportStar(require("./aco/api/gaps.js"), exports);
__exportStar(require("./aco/quality-report/figures.js"), exports);
__exportStar(require("./aco/quality-report/inactive.js"), exports);
__exportStar(require("./aco/quality-report/report-table.js"), exports);
__exportStar(require("./aco/quality-report/rules.js"), exports);
__exportStar(require("./aco/quality-report/wording.js"), exports);
//# sourceMappingURL=index.js.map